import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import useMeasure from 'react-use/lib/useMeasure';
import { useSpring, animated, config } from 'react-spring';
import { CaretIcon } from '@parchment/icons';
import { white } from '../Colors/Colors';
import Anchor from '../Typography/Anchor';
const AnimatedContent = animated(styled.div.withConfig({
  displayName: "ShowMoreContainer__AnimatedContent",
  componentId: "sc-1i8z8mk-0"
})(["overflow:hidden;position:relative;", ""], _ref => {
  let {
    truncated
  } = _ref;
  return truncated && css(["&:after{content:'';display:block;position:absolute;bottom:0;left:0;width:100%;height:0;box-shadow:0px -5px 10px 5px ", ";}"], white);
}));
const Toggle = /*#__PURE__*/styled(Anchor).attrs(props => ({
  as: 'button',
  name: 'show-more-toggle',
  ...props
})).withConfig({
  displayName: "ShowMoreContainer__Toggle",
  componentId: "sc-1i8z8mk-1"
})(["margin-top:10px;font-size:13px;"]);
const ToggleIcon = /*#__PURE__*/styled(CaretIcon).withConfig({
  displayName: "ShowMoreContainer__ToggleIcon",
  componentId: "sc-1i8z8mk-2"
})(["margin-left:0.5em;font-size:80%;"]);
export default function ShowMoreContainer(_ref2) {
  let {
    children,
    collapsedHeight = 50,
    showMore = /*#__PURE__*/React.createElement(React.Fragment, null, "Show More", /*#__PURE__*/React.createElement(ToggleIcon, {
      rotate: "0deg"
    })),
    showLess = /*#__PURE__*/React.createElement(React.Fragment, null, "Show Less", /*#__PURE__*/React.createElement(ToggleIcon, {
      rotate: "180deg"
    })),
    open: openProp = false,
    ...props
  } = _ref2;
  // tracks whether the we've expanded the content or not
  const [open, setOpen] = useState(openProp); // changes the open state when the open prop changes

  useEffect(() => {
    setOpen(openProp);
  }, [openProp]); // used to measure the actual size of the content. we'll use the ref on the actual div holding the content
  // the spring animation will go on a div surrounding that one because we need the div directly surrounding the
  // content to be full size and the animated div will expand/contract between the collapsed height and content
  // height

  const [contentRef, {
    height
  }] = useMeasure(); // whether the content is long enough to get truncated. we'll use this to determine whether or not to show the
  // show more/less toggle button.

  const truncated = height > collapsedHeight; // creates the spring animation styles to be injected into an 'animated' div (or animated styled.div in our case)

  const expand = useSpring({
    config: config.gentle,
    height: open ? "".concat(height, "px") : "".concat(!height ? collapsedHeight : Math.min(collapsedHeight, height), "px")
  });
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(AnimatedContent, {
    truncated: truncated && !open,
    style: expand
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentRef
  }, children)), !truncated ? null : /*#__PURE__*/React.createElement(Toggle, {
    onClick: () => setOpen(!open)
  }, open ? showLess : showMore));
}
export { Toggle, ToggleIcon };